import { createSlice } from '@reduxjs/toolkit';
import { submitEblConsent } from '../actions/eBLConsentActions';

interface EblState {
  hasConsent: boolean | null;
  consentLoading: boolean;
}

const initialState: EblState = {
  hasConsent: null,
  consentLoading: false,
};

const eblSlice = createSlice({
  name: 'ebl',
  initialState,
  reducers: {
    setHasConsent(state, action) {
      state.hasConsent = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitEblConsent.pending, (state) => {
        state.consentLoading = true;
      })
      .addCase(submitEblConsent.fulfilled, (state) => {
        state.consentLoading = false;
        state.hasConsent = true;
      })
      .addCase(submitEblConsent.rejected, (state) => {
        state.consentLoading = false;
      });
  },
});

export const { setHasConsent } = eblSlice.actions;
export default eblSlice.reducer;
